<table class="crm-table" id="all-clients">
    <thead>
        <tr>
            <th class="star-col sortable" (click)="sortData('isStarred')">
                <i class="fa-solid fa-star"></i>
            </th>
            <th *ngIf="visibleColumns['createdAt']" class="sortable" (click)="sortData('createdAt')">
                Created
                <i *ngIf="sortColumn === 'createdAt'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['status']" class="sortable" (click)="sortData('contactType')">
                Type
                <i *ngIf="sortColumn === 'contactType'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['leadStatus']" class="sortable" (click)="sortData('leadStatus')">
                Status
                <i *ngIf="sortColumn === 'leadStatus'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['userResponsible']" class="sortable" (click)="sortData('userResponsible')">
                User
                <i *ngIf="sortColumn === 'userResponsible'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['numberOfBays']" class="sortable" (click)="sortData('numberOfBays')">
                Bays
                <i *ngIf="sortColumn === 'numberOfBays'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['leadValue']">Value</th>
            <th *ngIf="visibleColumns['broadLocation']" class="sortable" (click)="sortData('broadLocation')">
                Location
                <i *ngIf="sortColumn === 'broadLocation'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['firstName']" class="sortable" (click)="sortData('firstName')">
                Name
                <i *ngIf="sortColumn === 'firstName'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['email']" class="sortable" (click)="sortData('email')">
                Email
                <i *ngIf="sortColumn === 'email'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['phoneNumber']" class="sortable" (click)="sortData('phoneNumber')">
                Phone
                <i *ngIf="sortColumn === 'phoneNumber'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['notes']" class="sortable" (click)="sortData('comment')">
                Notes
                <i *ngIf="sortColumn === 'comment'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['breachedSubscriptionsCount']" class="sortable" (click)="sortData('breachedSubscriptionsCount')">
                Breached
                <i
                    *ngIf="sortColumn === 'breachedSubscriptionsCount'"
                    class="sort-icon"
                    [class.fa-caret-up]="sortDirection === 'asc'"
                    [class.fa-caret-down]="sortDirection === 'desc'"
                    class="fa-solid"
                ></i>
            </th>
            <th *ngIf="visibleColumns['completedSubscriptionsCount']" class="sortable" (click)="sortData('completedSubscriptionsCount')">
                Completed
                <i
                    *ngIf="sortColumn === 'completedSubscriptionsCount'"
                    class="sort-icon"
                    [class.fa-caret-up]="sortDirection === 'asc'"
                    [class.fa-caret-down]="sortDirection === 'desc'"
                    class="fa-solid"
                ></i>
            </th>
            <th *ngIf="visibleColumns['activeSubscriptionExpiry']" class="sortable" (click)="sortData('activeSubscriptionExpiry')">
                Current
                <i
                    *ngIf="sortColumn === 'activeSubscriptionExpiry'"
                    class="sort-icon"
                    [class.fa-caret-up]="sortDirection === 'asc'"
                    [class.fa-caret-down]="sortDirection === 'desc'"
                    class="fa-solid"
                ></i>
            </th>
            <th *ngIf="visibleColumns['hasFutureSubscription']" class="sortable" (click)="sortData('hasFutureSubscription')">
                Future
                <i *ngIf="sortColumn === 'hasFutureSubscription'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['p_source']" class="sortable" (click)="sortData('p_source')">
                Source
                <i *ngIf="sortColumn === 'p_source'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['p_campaign']" class="sortable" (click)="sortData('p_campaign')">
                Campaign
                <i *ngIf="sortColumn === 'p_campaign'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
            <th *ngIf="visibleColumns['denormEnterpriseKey']" class="sortable" (click)="sortData('denormEnterpriseKey')">
                Enterprise
                <i *ngIf="sortColumn === 'denormEnterpriseKey'" class="sort-icon" [class.fa-caret-up]="sortDirection === 'asc'" [class.fa-caret-down]="sortDirection === 'desc'" class="fa-solid"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <tr
            *ngFor="let adminClient of filteredAdminClients"
            (contextmenu)="onContextMenu($event, adminClient)"
            (click)="leadClick.emit(adminClient)"
            class="client-row clickable-row"
            [class.starred]="adminClient.isStarred"
        >
            <td class="star-col">
                <button
                    class="star-btn"
                    [class.starred]="adminClient.isStarred"
                    (click)="toggleStar(adminClient); $event.stopPropagation()"
                    [attr.data-tooltip]="adminClient.isStarred ? 'Remove star' : 'Star this lead'"
                >
                    <i [class]="adminClient.isStarred ? 'fa-solid fa-star' : 'fa-regular fa-star'"></i>
                </button>
            </td>
            <td *ngIf="visibleColumns['createdAt']">{{ adminClient.createdAt | formatDate }}</td>
            <td *ngIf="visibleColumns['status']">
                <span *ngIf="adminClient.contactType === 'User' || !adminClient.contactType" class="badge badge--success">User</span>
                <span *ngIf="adminClient.contactType === 'Lead'" class="badge badge--primary">Lead</span>
                <span *ngIf="adminClient.contactType === 'Landlord'" class="badge badge--purple">Landlord</span>
            </td>
            <td *ngIf="visibleColumns['leadStatus']">
                <span *ngIf="adminClient.leadStatus" [class]="'badge lead-status lead-status--' + adminClient.leadStatus.toLowerCase().replace(' ', '-')">
                    {{ adminClient.leadStatus }}
                </span>
            </td>
            <td *ngIf="visibleColumns['userResponsible']">
                <span *ngIf="isValidAssignee(adminClient.userResponsible)" class="badge user-badge" [style.background-color]="getAssigneeBadgeColor(adminClient.userResponsible)">
                    {{ getAssigneeDisplayName(adminClient.userResponsible) }}
                </span>
            </td>
            <td *ngIf="visibleColumns['numberOfBays']">
                <div class="bays-cell">
                    <span class="bays-value">{{ adminClient.numberOfBays || '-' }}</span>
                    <span *ngIf="adminClient.monthsRequired" class="months-value">{{ adminClient.monthsRequired }} mo</span>
                </div>
            </td>
            <td *ngIf="visibleColumns['leadValue']">
                <span
                    *ngIf="adminClient.numberOfBays"
                    class="value-badge"
                    [class.value-badge--high]="getLeadValueTier(adminClient) === 'HIGH'"
                    [class.value-badge--medium]="getLeadValueTier(adminClient) === 'MEDIUM'"
                    [class.value-badge--low]="getLeadValueTier(adminClient) === 'LOW'"
                    [attr.data-tooltip]="getLeadValue(adminClient) | currency: 'R':'symbol':'1.0-0'"
                >
                    {{ getLeadValueTier(adminClient) }}
                </span>
                <span *ngIf="!adminClient.numberOfBays" class="text-muted">-</span>
            </td>
            <td *ngIf="visibleColumns['broadLocation']">{{ adminClient.broadLocation }}</td>
            <td *ngIf="visibleColumns['firstName']">
                <div class="name-cell">
                    <span class="client-name" [attr.data-tooltip]="getFullName(adminClient)">
                        <span [class.undefined]="!adminClient.firstName">{{ getFullName(adminClient) | truncate: [20, '...'] }}</span>
                    </span>
                    <span *ngIf="adminClient.companyName" class="company-name" [attr.data-tooltip]="adminClient.companyName">
                        {{ adminClient.companyName | truncate: [20, '...'] }}
                    </span>
                </div>
            </td>
            <td *ngIf="visibleColumns['email']">
                <div *ngIf="adminClient.email" class="contact-cell">
                    <span class="contact-text">{{ adminClient.email }}</span>
                    <button class="contact-btn contact-btn--email" (click)="sendEmail(adminClient.email); $event.stopPropagation()" data-tooltip="Send Email">
                        <i class="fa-solid fa-envelope"></i>
                    </button>
                </div>
            </td>
            <td *ngIf="visibleColumns['phoneNumber']">
                <div *ngIf="adminClient.phoneNumber" class="contact-cell">
                    <span class="contact-text">{{ adminClient.phoneNumber }}</span>
                    <button class="contact-btn contact-btn--call" (click)="callPhone(adminClient.phoneNumber); $event.stopPropagation()" data-tooltip="Call">
                        <i class="fa-solid fa-phone"></i>
                    </button>
                    <button class="contact-btn contact-btn--whatsapp" (click)="sendWhatsApp(adminClient.phoneNumber); $event.stopPropagation()" data-tooltip="WhatsApp">
                        <i class="fa-brands fa-whatsapp"></i>
                    </button>
                </div>
            </td>
            <td *ngIf="visibleColumns['notes']">
                <span *ngIf="adminClient.leadClosedReason" class="notes-text closed-reason" [attr.data-tooltip]="adminClient.leadClosedReason">
                    <i class="fa-solid fa-circle-xmark"></i> {{ adminClient.leadClosedReason | truncate: [15, '...'] }}
                </span>
                <div *ngIf="!adminClient.leadClosedReason" class="comments-cell">
                    <span *ngIf="adminClient.latestComment" [attr.data-tooltip]="adminClient.latestComment.text" class="notes-text">
                        {{ adminClient.latestComment.text | truncate: [20, '...'] }}
                    </span>
                    <span *ngIf="!adminClient.latestComment && adminClient.comment" [attr.data-tooltip]="adminClient.comment" class="notes-text legacy-comment">
                        {{ adminClient.comment | truncate: [20, '...'] }}
                    </span>
                    <span *ngIf="adminClient.commentsCount && adminClient.commentsCount > 1" class="comments-badge" [attr.data-tooltip]="adminClient.commentsCount + ' comments'">
                        {{ adminClient.commentsCount }}
                    </span>
                </div>
            </td>
            <td *ngIf="visibleColumns['breachedSubscriptionsCount']" class="text-center">{{ getBreachedSubCount(adminClient) }}</td>
            <td *ngIf="visibleColumns['completedSubscriptionsCount']" class="text-center">{{ getCompletedSubCount(adminClient) }}</td>
            <td *ngIf="visibleColumns['activeSubscriptionExpiry']">
                <span [class]="hasActiveSub(adminClient) ? 'badge badge--success' : 'badge badge--danger'">
                    {{ hasActiveSub(adminClient) ? (getActiveSubExpiry(adminClient) | daysUntil) : 'No' }}
                </span>
            </td>
            <td *ngIf="visibleColumns['hasFutureSubscription']">
                <span [class]="hasFutureSub(adminClient) ? 'badge badge--success' : 'badge badge--danger'">
                    {{ hasFutureSub(adminClient) ? 'Yes' : 'No' }}
                </span>
            </td>
            <td *ngIf="visibleColumns['p_source']">
                <span *ngIf="adminClient.p_source" class="source-badge clickable" (click)="navigateToReporting(adminClient.p_source, undefined); $event.stopPropagation()">
                    {{ adminClient.p_source }}
                </span>
                <span *ngIf="!adminClient.p_source" class="text-muted">-</span>
            </td>
            <td *ngIf="visibleColumns['p_campaign']">
                <span *ngIf="adminClient.p_campaign" class="campaign-link clickable" (click)="navigateToReporting(adminClient.p_source, adminClient.p_campaign); $event.stopPropagation()">
                    {{ adminClient.p_campaign }}
                </span>
                <span *ngIf="!adminClient.p_campaign" class="text-muted">-</span>
            </td>
            <td *ngIf="visibleColumns['denormEnterpriseKey']">
                <span *ngIf="adminClient.denormEnterpriseKey" class="badge badge--info text-capitalize">
                    {{ adminClient.denormEnterpriseKey }}
                </span>
                <span *ngIf="!adminClient.denormEnterpriseKey" class="text-muted">-</span>
            </td>
        </tr>
    </tbody>
</table>
